{
  "title": "Aide et support",
  "description": "Problèmes clients et demandes d'assistance",
  "tabs": {
    "customerIssues": "Problèmes clients",
    "contact": "Obtenir de l'aide"
  },
  "searchPlaceholder": "Rechercher...",
  "emptyTitle": "Aucun problème client",
  "emptyDescription": "Les problèmes signalés par les clients apparaîtront ici.",
  "contact": {
    "title": "Contacter ForumOne",
    "description": "Soumettez une demande et notre équipe vous répondra.",
    "categoryLabel": "Catégorie",
    "categoryPlaceholder": "Choisir une catégorie",
    "subjectLabel": "Sujet",
    "subjectPlaceholder": "Résumé bref",
    "messageLabel": "Message",
    "messagePlaceholder": "Décrivez votre problème",
    "submit": "Envoyer",
    "success": "Demande envoyée",
    "error": "Échec de l'envoi"
  },
  "columns": {
    "ticketId": "ID ticket",
    "customer": "Client",
    "service": "Service",
    "status": "Statut",
    "category": "Catégorie"
  },
  "status": {
    "all": "Tous",
    "pending": "En attente",
    "inReview": "En cours",
    "refunded": "Remboursé",
    "rejected": "Rejeté",
    "resolved": "Résolu",
    "cancelled": "Annulé"
  },
  "categories": {
    "APPOINTMENT_DISPUTE": "Litige rendez-vous",
    "BOOKING": "Réservation",
    "PAYMENT": "Paiement",
    "PAYOUT": "Versement",
    "SUBSCRIPTION": "Abonnement",
    "ACCOUNT": "Compte",
    "TECHNICAL": "Technique",
    "GENERAL": "Autre"
  },
  "modal": {
    "customer": "Client",
    "provider": "Prestataire",
    "noProvider": "Aucun prestataire",
    "noProviderEmail": "Pas d'e-mail"
  }
}
